import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchMediaMap, fetchProjects } from "../services/wpPagesApi";
import { buildProjectGalleries } from "../utils/projectGalleries";
import {
  collectProjectMediaIds,
  enrichProjectsWithAttachments,
  getProjectsGalleryItems,
} from "../utils/projectMedia";

export function useProjects({ perPage = 100 } = {}) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [projects, setProjects] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchProjects({ perPage, lang })
      .then(async (items) => {
        if (cancelled) return;

        const mediaIds = collectProjectMediaIds(items);
        const mediaMap = mediaIds.length > 0 ? await fetchMediaMap(mediaIds) : {};
        const projectOptions = { lang };
        const enrichedProjects = await enrichProjectsWithAttachments(items, mediaMap, projectOptions);
        const gallery = getProjectsGalleryItems(enrichedProjects, mediaMap, projectOptions);
        const groupedGalleries = buildProjectGalleries(enrichedProjects, mediaMap, projectOptions);

        if (!cancelled) {
          setProjects(enrichedProjects);
          setGalleryItems(gallery);
          setGalleries(groupedGalleries);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setProjects([]);
          setGalleryItems([]);
          setGalleries([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [lang, perPage]);

  return { projects, galleryItems, galleries, loading, error };
}
